import { Outlet } from 'react-router-dom'
import { Box, Container } from '@mui/material'
import { ViewAsBanner } from '@/components/view-as-banner/view-as-banner'
import { isViewAs } from '@/helpers'

export function BaseLayout() {
  return (
    <Box display="flex" flexDirection="column" height="100vh">
      {isViewAs() && <ViewAsBanner />}
      <Container sx={{ flex: 1, minHeight: 0 }}>
        <Box
          component="main"
          height="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Outlet />
        </Box>
      </Container>
    </Box>
  )
}
